import { isNil } from 'lodash-es';
/**
 * Defines a custom element for the specified name and options.
 *
 * @param {string} name - The name of the custom element.
 * @param {ElementDefinitionOptions} [options] - The options for the custom element.
 * @return {(target: CustomElementClass, context?: ClassDecoratorContext<Constructor<HTMLElement>>) => void} The function to define the custom element.
 */
export function sdsCustomElement(name, options) {
    return (target, context) => {
        if (!isNil(context)) {
            context.addInitializer(() => {
                initComponent(name, target, options);
            });
        }
        else {
            initComponent(name, target, options);
        }
    };
}
function initComponent(name, target, options) {
    if (isNil(window.customElements.get(name))) {
        customElements.define(name, target, options);
    }
    else {
        console.warn(`Custom element ${name} is already defined`);
    }
}
